import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { closePopup } from '../../actions/uiActions';
import { createTeam } from '../../actions/userActions';
import CloseIcon from '@mui/icons-material/Close';

class AddTeam extends React.Component {
    state = {
        teamName: "",
        customerID: "",
    }

    componentDidMount() {
        if (this.props.role === "ClientAdmin" && this.props.currentUser && this.props.currentUser.customerID) {
            let selectedCustomerId = this.props.currentUser.customerID
            this.setState({ customerID: selectedCustomerId })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.role === "ClientAdmin" && this.props.role !== prevProps.role && this.props.currentUser && this.props.currentUser.customerID) {
            let selectedCustomerId = this.props.currentUser.customerID
            this.setState({ customerID: selectedCustomerId })
        }
    }

    changeName = (event) => {
        this.setState({ teamName: event.target.value })
    }


    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.props.createTeam(this.state.teamName, this.state.customerID)
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ customerID: event.target.value })
    }

    populateCustomers = () => {
        let selectedCustomerId = this.props.currentUser.customerID
        
        if (this.props.role === "IEAdmin") {
            return (
                <Select
                    className="myInput"
                    defaultValue=""
                    onChange={this.handleCustomerID}
                    value={this.state.customerID}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="" disabled hidden>Select Customer</MenuItem>
    
                    {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                </Select>
            )
        } else {
            return (
                <Select
                    className="myInput"
                    defaultValue=""
                    onChange={() => {}}
                    value={selectedCustomerId}
                    disabled={true}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem value="" disabled hidden>Select Customer</MenuItem>
                    {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                </Select>
            )
        }
    }

    render() {
        return (
            <>
                <Dialog
                    open={true}
                    onClose={this.handleClick}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <CloseIcon onClick={this.handleClick} className="closePoup" />
                    <DialogTitle id="alert-dialog-title" className="changepassdialog">
                        Add A New Team
                </DialogTitle>
                    <DialogContent>
                        <form className="form" onSubmit={this.handleSubmit} >
                            {this.populateCustomers()}
                            <div className="myInputOut">
                                <input
                                    type="text"
                                    className="myInput"
                                    onChange={this.changeName}
                                    value={this.state.teamName}
                                    placeholder="Team Name"
                                    required
                                />
                            </div>
                            <button className="btn" type="submit" value="Submit" id="submit_btn">
                                Submit
                            </button>
                        </form>
                    </DialogContent>
                </Dialog>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        role: state.users.role,
        currentUser: state.users.currentUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, createTeam }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddTeam)